import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import jwtAuthAxios, {setTokenManual} from "../../services/jwtAuth";
import registerAxios from "../../services/jwtAuth";
import jwtAuth from "../../services/jwtAuth";
import axios from "axios";
export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null
}
export const signIn =
	createAsyncThunk('auth/signIn',async (data, { rejectWithValue }) => {
	const { email, password } = data
	try {
		let loginCreds = {email, password};
		const response = await jwtAuthAxios.post('/v1/auth/authenticate', loginCreds);
		if (response.data) {
			//console.log("response.data : ",JSON.stringify(response.data))
			if (response.data.result) {
				const token = response.data.token.access_token;
				const roles = response.data.roles;
				
				localStorage.setItem(AUTH_TOKEN, token);
				localStorage.setItem('roles', roles);
				localStorage.setItem('user_id', response.data.user_id);
				localStorage.setItem('camaba_id', response.data.camaba_id);
				localStorage.setItem('registration_id', response.data.registration_id);
				localStorage.setItem('prodi_id', response.data.prodi_id);
				
				setTokenManual(token);
				return token;
			} else {
				return rejectWithValue('Not Authorize');
			}
		} else {
			//return rejectWithValue(response.message?.replace('Firebase: ', ''));
			return rejectWithValue('Not Authorize');
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})


export const signUp =
	createAsyncThunk('auth/signUp',async (data, { rejectWithValue }) => {
	const { firstName,lastName,email, password,role,mobilePhone } = data
	try {
		let loginCreds = {firstName,lastName,email, password,role,mobilePhone};
		const response = await axios.post('/pmb/auth/register', loginCreds);
		return response.data;
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

const IMPERSONATE_ACTIVE = 'impersonate_active';
const IMPERSONATE_BACKUP = 'impersonate_backup';
const IMPERSONATE_NAME = 'impersonate_name';

export const isImpersonating = () => localStorage.getItem(IMPERSONATE_ACTIVE) === 'true';

export const impersonateUser =
	createAsyncThunk('auth/impersonate', async (user, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem(AUTH_TOKEN);
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
		const response = await jwtAuthAxios.post(`v1/users/impersonate/${user.id}`);
		const data = response.data;
		if (data && data.result) {
			// backup current (admin) session so we can return to it later
			const backup = {
				auth_token: localStorage.getItem(AUTH_TOKEN),
				roles: localStorage.getItem('roles'),
				user_id: localStorage.getItem('user_id'),
				camaba_id: localStorage.getItem('camaba_id'),
				registration_id: localStorage.getItem('registration_id'),
				prodi_id: localStorage.getItem('prodi_id'),
			};
			localStorage.setItem(IMPERSONATE_BACKUP, JSON.stringify(backup));
			localStorage.setItem(IMPERSONATE_ACTIVE, 'true');
			localStorage.setItem(IMPERSONATE_NAME, user.firstname || user.username || ('User #' + user.id));

			// switch to impersonated user's session
			const newToken = data.token.access_token;
			localStorage.setItem(AUTH_TOKEN, newToken);
			localStorage.setItem('roles', data.roles);
			localStorage.setItem('user_id', data.user_id);
			localStorage.setItem('camaba_id', data.camaba_id ?? '');
			localStorage.setItem('registration_id', data.registration_id ?? '');
			localStorage.setItem('prodi_id', data.prodi_id ?? '');
			setTokenManual(newToken);
			return newToken;
		}
		return rejectWithValue('Gagal impersonate');
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || err.message || 'Error');
	}
})

// Restore the original admin session (synchronous helper).
export const stopImpersonate = () => {
	const raw = localStorage.getItem(IMPERSONATE_BACKUP);
	if (raw) {
		try {
			const b = JSON.parse(raw);
			localStorage.setItem(AUTH_TOKEN, b.auth_token ?? '');
			localStorage.setItem('roles', b.roles ?? '');
			localStorage.setItem('user_id', b.user_id ?? '');
			localStorage.setItem('camaba_id', b.camaba_id ?? '');
			localStorage.setItem('registration_id', b.registration_id ?? '');
			localStorage.setItem('prodi_id', b.prodi_id ?? '');
			setTokenManual(b.auth_token ?? '');
		} catch (e) { /* ignore */ }
	}
	localStorage.removeItem(IMPERSONATE_BACKUP);
	localStorage.removeItem(IMPERSONATE_ACTIVE);
	localStorage.removeItem(IMPERSONATE_NAME);
}

export const signOut = createAsyncThunk('auth/signOut',async () => {
    const response = await FirebaseService.signOutRequest()
	localStorage.removeItem(AUTH_TOKEN);
	localStorage.removeItem("roles");
	// clear any impersonation artifacts on full sign-out
	localStorage.removeItem(IMPERSONATE_BACKUP);
	localStorage.removeItem(IMPERSONATE_ACTIVE);
	localStorage.removeItem(IMPERSONATE_NAME);
    return response.data
})

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/auth/login'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				//state.redirect = '/'
				//state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const { 
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer